var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0654 0.779565C19.6605 0.184481 20.6253 0.184481 21.2204 0.779565C21.8155 1.37465 21.8155 2.33947 21.2204 2.93456L13.155 10.9999L21.2204 19.0653C21.8155 19.6604 21.8155 20.6252 21.2204 21.2203C20.6253 21.8154 19.6605 21.8154 19.0654 21.2203L10.9987 13.1546L2.93468 21.2203C2.3396 21.8154 1.37477 21.8154 0.779687 21.2203C0.184603 20.6252 0.184603 19.6604 0.779687 19.0653L8.84505 10.9999L0.779687 2.93456C0.184603 2.33947 0.184603 1.37465 0.779687 0.779565C1.37477 0.184481 2.3396 0.184481 2.93468 0.779565L11 8.84392L19.0654 0.779565Z",
    fill: "#222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.7f549529b35e1d73823bf7809bb354a1.svg";
export { ForwardRef as ReactComponent };